<h2 mat-dialog-title class="title-small">{{ title }}</h2>
<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field fxFlex class="custom-text-field" appearance="outline">
                <mat-label>Code</mat-label>
                <input matInput formControlName="code" placeholder="e.g. HOTK">
            </mat-form-field>
            <mat-form-field fxFlex class="custom-text-field" appearance="outline">
                <mat-label>Display Name</mat-label>
                <input matInput formControlName="displayName" placeholder="Category name">
            </mat-form-field>
        </div>

        <mat-checkbox
            *ngIf="data.mode === 'add'"
            formControlName="isStorage"
            [disabled]="isStorageDisabled">
            Storage
        </mat-checkbox>

        <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput rows="2" formControlName="description"></textarea>
        </mat-form-field>

        <div class="theme-picker-field" fxLayout="column" fxLayoutGap="8px">
            <div class="body-2-semi-bold">Theme</div>
            <div class="theme-picker-row">
                <input
                    #themePicker
                    type="color"
                    class="theme-picker-input"
                    [value]="themeColorValue"
                    (input)="onThemeColorChange(themePicker.value)"
                    aria-label="Theme color">
                <mat-form-field class="custom-text-field theme-picker-text-field" appearance="outline">
                    <mat-label>Hex code</mat-label>
                    <input
                        #themeTextInput
                        matInput
                        formControlName="theme"
                        placeholder="#2500fe"
                        maxlength="7"
                        spellcheck="false"
                        (input)="onThemeTextInput(themeTextInput.value)"
                        (blur)="onThemeTextBlur(themeTextInput.value)">
                    <mat-error *ngIf="form.get('theme')?.invalid">
                        Enter a valid hex color like #2500fe
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="svg-library-section" fxLayout="column" fxLayoutGap="12px">
            <div>
                <div class="body-1-semi-bold">Category SVG</div>
            </div>

            <mat-form-field class="custom-text-field" appearance="outline">
                <mat-label>Search SVG library</mat-label>
                <input matInput [formControl]="svgSearchControl" placeholder="Try bakery, prep, storage, chef...">
                <mat-icon matSuffix color="primary">search</mat-icon>
            </mat-form-field>

            <mat-progress-bar *ngIf="isLoadingSvgLibrary" mode="indeterminate"></mat-progress-bar>
            <span class="body-1-error" *ngIf="svgLibraryErrorMessage">{{ svgLibraryErrorMessage }}</span>

            <div class="selected-svg-card" *ngIf="hasSvgSelection">
                <div class="logo-preview">
                    <img [src]="logoPreviewDataUrl" alt="Category logo preview">
                </div>
            </div>

            <div class="svg-color-picker-field" fxLayout="column" fxLayoutGap="8px" *ngIf="canEditSvgColor">
                <div class="body-2-semi-bold">SVG color</div>
                <div class="theme-picker-row">
                    <input
                        #svgColorPicker
                        type="color"
                        class="theme-picker-input"
                        [value]="svgColorValue"
                        (input)="onSvgColorChange(svgColorPicker.value)"
                        aria-label="SVG color">
                    <mat-form-field class="custom-text-field theme-picker-text-field" appearance="outline">
                        <mat-label>Hex code</mat-label>
                        <input
                            #svgColorTextInput
                            matInput
                            formControlName="svgColor"
                            placeholder="#2500fe"
                            maxlength="7"
                            spellcheck="false"
                            (input)="onSvgColorTextInput(svgColorTextInput.value)"
                            (blur)="onSvgColorTextBlur(svgColorTextInput.value)">
                        <mat-error *ngIf="form.get('svgColor')?.invalid">
                            Enter a valid hex color like #2500fe
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="svg-library-results" *ngIf="svgLibraryItems.length; else emptySvgLibrary">
                <div class="svg-library-grid">
                    <button
                        type="button"
                        class="svg-library-card"
                        *ngFor="let item of svgLibraryItems"
                        (click)="selectSvgLibrary(item)"
                        [class.is-selected]="item.id === selectedSvgLibrary?.id"
                        [attr.aria-label]="item.name || item.code">
                        <div class="svg-library-card__preview">
                            <img [src]="getSvgDataUrl(item.svg)" [alt]="item.name">
                        </div>
                    </button>
                </div>
            </div>

            <ng-template #emptySvgLibrary>
                <div class="svg-library-results" *ngIf="!isLoadingSvgLibrary">
                    <div class="svg-library-empty">
                        No SVGs matched this search yet.
                    </div>
                </div>
            </ng-template>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onSave()" [disabled]="form.invalid">Save</button>
</mat-dialog-actions>
